export default "__VITE_ASSET__Comh7lI3__"